import React, { useCallback, memo } from 'react';
import { connect } from 'react-redux';
import SwitchListItem from '../../../../../../list-items/SwitchListItem/SwitchListItem';
import { createActions } from '../../../../store';

const WaveLayerSmoothListItem = memo(({ index, smoothed, updateWaveLayerCustomOptions }) => {
    const handleChange = useCallback(
        (_, value) => updateWaveLayerCustomOptions(index, "smoothed", value),
        [index]
    );

    return (
        <SwitchListItem
            checked={smoothed}
            onChange={handleChange}
            text="Smooth"
        />
    );
});

const mapStateToProps = (state, { index }) => {
    const { smoothed } = state.createPreview.present.videoSettings.visualizer.waveCircles[index].customOptions;
    return { smoothed };
}

const mapDispatchToProps = (dispatch) => ({
    updateWaveLayerCustomOptions: (index, key, value) => dispatch(createActions.updateWaveLayerCustomOptions(index, key, value))
});

export default connect(mapStateToProps, mapDispatchToProps)(WaveLayerSmoothListItem);
